import { styled } from '@mui/material/styles';
import React from 'react';

const Seperator = styled('div')(() => ({
  margin: '20px 0 10px',
  textAlign: 'center',
  borderTop: '1px solid #eaeaf1',
  color: '#ced0df',
}));

const SeperatorText = styled('span')(() => ({
  padding: '0 10px',
  background: '#fff',
  position: 'relative',
  top: '-11px',
  zIndex: '1',
  color: '#CED0DF',
  fontWeight: '600',
  fontSize: '17px',
  lineHeight: '21px',
}));

const TextOnLine: React.FC = ({ children }) => (
  <Seperator>
    <SeperatorText>{children}</SeperatorText>
  </Seperator>
);

export default TextOnLine;
